import { useContext } from 'react';
import AppContext from '../../../common/containers/AppContext';
import getStatsByApplicationForFamilyById from '../getStatsByApplicationForFamilyById';

/**
 * Gets applications with their available stats
 *
 * @param {number} familyId
 * @returns {import(../getStatsByApplicationForFamilyById).ApplicationWithStats[]}
 */
export default function useGetApplicationsWithStatsByFamilyId(familyId) {
    const appContext = useContext(AppContext);
    const families = appContext.families || [];

    return [getStatsByApplicationForFamilyById(families, familyId), false, false];
}
